import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface DepositReceiptDialogData {
  numeroDistinta: string;
  dataConferma: string;
  totaleContanti: number;
  totaleAssegni: number;
  totaleDistinta: number;
  situazione: string;
}

@Component({
  selector: 'rev-receipts-deposit-receipt-dialog-component',
  imports: [DatePipe, MatButtonModule, MatDialogModule],
  templateUrl: './receipts-deposit-receipt-dialog-component.html',
  styleUrl: './receipts-deposit-receipt-dialog-component.scss',
})
export class receiptsDepositReceiptDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) readonly data: DepositReceiptDialogData) {}

  formatAmount(value: number): string {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
}
